import { User, Building2, Mail, Phone, CreditCard, MapPin, Hash, Info } from 'lucide-react';
import { useCreatorPortal } from '../../contexts/CreatorPortalContext';
import { useLanguage } from '../../contexts/LanguageContext';

export function CreatorProfileTab() {
  const { t } = useLanguage();
  const { influencer } = useCreatorPortal();

  if (!influencer) return null;

  const fields = [
    { icon: User, label: t('creatorsHub.profile.fullName'), value: influencer.full_name },
    { icon: Mail, label: t('creatorsHub.profile.email'), value: influencer.email },
    { icon: Building2, label: t('creatorsHub.profile.company'), value: influencer.company_name },
    { icon: Hash, label: t('creatorsHub.profile.taxNumber'), value: influencer.vat_number },
    { icon: Phone, label: t('creatorsHub.profile.phone'), value: influencer.phone },
    { icon: CreditCard, label: t('creatorsHub.profile.iban'), value: influencer.iban, mono: true },
    { icon: MapPin, label: t('creatorsHub.profile.address'), value: influencer.address, fullWidth: true },
  ];

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-bold text-gray-900">{t('creatorsHub.myProfile')}</h2>

      <div className="bg-white rounded-2xl shadow-sm ring-1 ring-gray-100 border border-gray-100 overflow-hidden">
        <div className="p-6">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-16 h-16 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-2xl flex items-center justify-center text-white text-xl font-bold shadow-sm">
              {influencer.full_name?.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase()}
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900">{influencer.full_name}</h3>
              {influencer.company_name && (
                <p className="text-sm text-gray-500">{influencer.company_name}</p>
              )}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {fields.map((f, i) => {
              const FieldIcon = f.icon;
              return (
                <div key={i} className={f.fullWidth ? 'md:col-span-2' : ''}>
                  <div className="flex items-center gap-2 mb-1">
                    <FieldIcon className="w-3.5 h-3.5 text-gray-400" />
                    <label className="text-xs font-medium text-gray-500 uppercase tracking-wider">{f.label}</label>
                  </div>
                  <p className={`text-sm text-gray-900 ${f.mono ? 'font-mono' : ''}`}>
                    {f.value || '-'}
                  </p>
                </div>
              );
            })}
          </div>
        </div>

        <div className="bg-blue-50 border-t border-blue-100 px-6 py-4 flex items-start gap-3">
          <Info className="w-4 h-4 text-blue-600 flex-shrink-0 mt-0.5" />
          <p className="text-sm text-blue-800">
            {t('creatorsHub.profile.updateNote')}
          </p>
        </div>
      </div>
    </div>
  );
}
